var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "booking-toolbar" }, [
    _c(
      "div",
      { staticClass: "booking-toolbar__wrap" },
      [
        _setup.props.ForOverview
          ? [
              _c("div", { staticClass: "booking-toolbar__total-cabins" }, [
                _c(
                  "div",
                  { staticClass: "booking-toolbar__selected-cabins" },
                  _vm._l(
                    _setup.cstore.getCabins,
                    function ({ id, Cabin, CabinSet }) {
                      return _c(_setup.RoomSelector, {
                        key: id,
                        attrs: {
                          Cabin: Cabin,
                          CabinSet: CabinSet,
                          For: "toolbar",
                        },
                      })
                    }
                  ),
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn booking-toolbar__button",
                  attrs: { disabled: !_setup.cstore.getCabins.length },
                  on: { click: _setup.fill_click },
                },
                [_vm._v("\n                Забронировать\n            ")]
              ),
            ]
          : _setup.props.ForFill
          ? [
              _c("div", { staticClass: "booking-toolbar__total-price" }, [
                _c("div", { staticClass: "booking-toolbar__text" }, [
                  _vm._v("Итого: "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _setup.bookPrecalc
                      ? _c(_setup.PriceCurrencyV, {
                          staticClass: "booking-toolbar__price",
                          attrs: { price: _setup.bookPrecalcSum, sum: true },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "booking-toolbar__wrapButs" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn booking-toolbar__linkbut",
                    on: { click: _setup.cruise_click },
                  },
                  [
                    _c("span", { staticClass: "desktop" }, [
                      _vm._v("Выбрать другие каюты"),
                    ]),
                    _c("span", { staticClass: "mobile" }, [_vm._v("Назад")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn booking-toolbar__button",
                    attrs: { disabled: _setup.errors.length > 0 },
                    on: { click: _setup.preview_click },
                  },
                  [
                    _c("span", { staticClass: "desktop" }, [
                      _vm._v("Проверить и забронировать"),
                    ]),
                    _c("span", { staticClass: "mobile" }, [
                      _vm._v("Забронировать"),
                    ]),
                  ]
                ),
              ]),
            ]
          : _setup.props.ForBook
          ? [
              _c("div", { staticClass: "booking-toolbar__total-price" }, [
                _c("div", { staticClass: "booking-toolbar__text" }, [
                  _vm._v("Итого: "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _setup.bookPrecalc
                      ? _c(_setup.PriceCurrencyV, {
                          staticClass: "booking-toolbar__price",
                          attrs: { price: _setup.bookPrecalcSum, sum: true },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "booking-toolbar__wrapButs" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn booking-toolbar__linkbut",
                    on: { click: _setup.fill_click },
                  },
                  [
                    _c("span", { staticClass: "desktop" }, [
                      _vm._v("Вернуться"),
                    ]),
                    _c("span", { staticClass: "mobile" }, [_vm._v("Назад")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn booking-toolbar__button",
                    attrs: { disabled: !_setup.props.maybook.may },
                    on: { click: _setup.book_click },
                  },
                  [
                    _vm._v(
                      "\n                    Забронировать\n                "
                    ),
                  ]
                ),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }